export default __webpack_public_path__ + "static/media/safeBox.e3e9509c.png";